import { Component, Inject, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RutaCriticaService } from './services/ruta-critica.service';
import { IGetActividadesRequest } from './interfaces/ruta-critica.interface';

@Component({
  selector: 'app-ruta-form-dialog',
  templateUrl: './ruta-form-dialog.component.html'
})
export class RutaFormDialogComponent implements OnInit, OnChanges {
  @Input() model: any = null;
  @Input() visible: boolean = false;
  @Input() numeroProceso: number = 0;
  @Output() visibleChange = new EventEmitter<any>();

  form: FormGroup;
  actividades: { numero_actividad: number, descripcion: string }[] = [];

  constructor(
    private fb: FormBuilder,
    private rutaCriticaService: RutaCriticaService,
    @Inject(MAT_DIALOG_DATA) public data: { numero_Proceso: number } | null = null
  ) {
    this.form = this.fb.group({
      numero_Proceso: [{ value: 0, disabled: true }],
      comenzarActividad: [null, Validators.required],
      terminarActividad: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    if (this.numeroProceso) {
      this.form.patchValue({ numero_Proceso: this.numeroProceso });
      this.cargarActividades();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['numeroProceso'] && changes['numeroProceso'].currentValue) {
      this.form.patchValue({ numero_Proceso: changes['numeroProceso'].currentValue });
      if (!changes['numeroProceso'].firstChange) {
        this.cargarActividades();
      }
    }
    if (changes['model'] && changes['model'].currentValue) {
      // Aquí puedes cargar los datos de la ruta seleccionada si es edición
    }
  }

  cargarActividades() {
    const request: IGetActividadesRequest = {
      tope: '999',
      numero_proceso: this.numeroProceso,
      numero_actividad: 0,
      descripcion: '',
      tipo_actividad: '',
      dependencia: '',
      tiempo_estimado: 0,
      dias_semana: '',
      horas: 0,
      minutos: 0,
      horas_dia: '',
      costo_estimado: 0,
      marcaje_automatico: '',
      envio_carta: '',
      procesoAutomatico: '',
      cuentaCredito: '',
      accion: '',
      resultado: '',
      responsable: '',
      carta: '',
      encuesta: '',
      decisiones: ''
    };
    this.rutaCriticaService.getActividades(request).subscribe({
      next: (res) => {
        if (res.success) {
          this.actividades = res.data.map(a => ({
            numero_actividad: a.numero_actividad,
            descripcion: `${a.numero_actividad} | ${a.descripcion}`
          }));
        } else {
          this.actividades = [];
        }
      }
    });
  }

  aceptar() {
    if (this.form.valid) {
      const request = {
        que: 1,
        tope: '',
        proceso: this.numeroProceso,
        origen: this.form.get('comenzarActividad')?.value,
        destino: this.form.get('terminarActividad')?.value,
        decision: '',
        correcta: 0
      };

      this.rutaCriticaService.guardarRuta(request).subscribe({
        next: (response) => {
          if (response.success) {
            this.visibleChange.emit({ refresh: true, numero_Proceso: this.numeroProceso, success: true });
          } else {
            this.visibleChange.emit({ refresh: false, success: false });
          }
        },
        error: (error) => {
          console.error('Error al guardar la ruta:', error);
          this.visibleChange.emit({ refresh: false, success: false });
        }
      });
    }
  }

  cerrar() {
    this.visibleChange.emit(false);
  }
} 